/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Operations_Title_1Inputs */

const en_wb_operations_title_1 = /** @type {(inputs: Wb_Operations_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The order is entered.`)
};

const lv_wb_operations_title_1 = /** @type {(inputs: Wb_Operations_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījums ir ievadīts.`)
};

/**
* | output |
* | --- |
* | "The order is entered." |
*
* @param {Wb_Operations_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_operations_title_1 = /** @type {((inputs?: Wb_Operations_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Operations_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_operations_title_1(inputs)
	return en_wb_operations_title_1(inputs)
});